module.exports = __webpack_public_path__ + "img/12.7e954a7e.jpg";